import ajax from './ajax'

const BASE_URL = '/webhard'

const _webhard = {
  getList(br_cd, year_cd, sesn_cd) {
    return ajax.get(`${BASE_URL}/list`, {
      br_cd,
      year_cd,
      sesn_cd,
    })
  },

  getZip(brand, style, color, year, season) {
    return ajax.download('get', `${BASE_URL}/zip`, {
      brand,
      style,
      color,
      year,
      season,
    })
  },
}

export default _webhard
